import React from "react";
import "./layout.css";
import { Oval } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="loader">
      <Oval
        height={40}
        width={40}
        color="#f00"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#f00"
        strokeWidth={4}
        strokeWidthSecondary={4}
      />
    </div>
  );
};

export default Loader;
